module.exports = __webpack_public_path__ + "img/login_content_bg.7964b170.png";